import {globalState} from "@utils";
import {PowellConfig} from "@models";

export const configService = globalState<PowellConfig>({});
